import { Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ReactComponent as MediaIcon } from 'assets/icons/edit-image.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-white.svg';
import { DrawerMedia, GridWrap, InfoWrapper, Table } from 'components';
import { FieldType, MediaGroup, UploadMedia } from 'constants/inspections';
import {
  tipoElementoAggiuntivoCollegamentiOptions,
  tipologiaElementoExtraOptions,
} from 'constants/selectOptions';
import { useInspectionPath } from 'hooks';
import { INFO } from 'pages/Inspections/config/info';
import { useInspectionSelector } from 'stores';
import ElementiAggiuntiviForm from './ElementiAggiuntiviForm';

const ElementiAggiuntiviSection = ({ selectedIdx }) => {
  const { watch, setValue, getValues } = useFormContext();
  const { inspectionDisabled } = useInspectionSelector();
  const { isViewingInspection } = useInspectionPath();

  const spallePileCollegamentiTableExtraTableWatch = watch(
    `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`
  );

  console.log(spallePileCollegamentiTableExtraTableWatch, 'lauta');
  // table setup
  const dataConfigElementiExtra = {
    columns: {
      codice: { label: 'Codice' },
      nomeElementoExtra: { label: 'Nome Elemento' },
      tipoElementoExtra: {
        label: 'Tipo Elemento',
        format: tipoElementoAggiuntivoCollegamentiOptions,
      },
      tipologiaElementoExtra: {
        label: 'Tipologia',
        format: tipologiaElementoExtraOptions,
      },
      altezzaElementoExtra: {
        label: 'H [cm]',
      },
      larghezzaElementoExtra: {
        label: 'L [cm]',
      },
      profonditaElementoExtra: {
        label: 'P [cm]',
      },
      superficieElementoExtra: {
        label: 'Sup. [m²]',
        formatValue: val => `${(+val)?.toFixed(2)}`,
      },
    },
  };

  const [selectedElementiExtra, setSelectedElementiExtra] = useState([]);
  const [open, setOpen] = useState(false);
  const [drawerMediaIndex, setDrawerMediaIndex] = useState();

  const editRowsElementiExtra = item => {
    setValue('l0t2a6_elementiAggiuntiviTable', [item]);
    setValue('l0t2a6_nomeElementoAggiuntivoTableValue', item.nomeElementoExtra);
    setValue('l0t2a6_tipoElementoAggiuntivoTableValue', item.tipoElementoExtra);
    setValue(
      'l0t2a6_tipologiaElementoAggiuntivoTableValue',
      item.tipologiaElementoExtra
    );
    setValue(
      'l0t2a6_altezzaElementoAggiuntivoTableValue',
      item.altezzaElementoExtra
    );
    setValue(
      'l0t2a6_larghezzaElementoAggiuntivoTableValue',
      item.larghezzaElementoExtra
    );
    setValue(
      'l0t2a6_profonditaElementoAggiuntivoTableValue',
      item.profonditaElementoExtra
    );
    setValue(
      'l0t2a6_superficieElementoAggiuntivoTableValue',
      item.superficieElementoExtra
    );
  };

  const handleSelectAllClickElementiExtra = event => {
    if (event.target.checked) {
      const selectedValue = getValues(
        `spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`
      );
      setSelectedElementiExtra(selectedValue);
      setValue('l0t2a6_elementiAggiuntiviTableValue', selectedValue);
    } else {
      setSelectedElementiExtra([]);
      setValue('l0t2a6_elementiAggiuntiviTableValue', []);
    }
  };

  return (
    <>
      <GridWrap container spacing={2} style={{ marginTop: 16 }}>
        <InfoWrapper
          isDivider={true}
          size={12}
          infoDrawer={true}
          drawerTitle={INFO.impalcatoElementiExtra.drawerTitle}
          drawerText={INFO.impalcatoElementiExtra.drawerText}
        >
          <Divider>ELEMENTI AGGIUNTIVI</Divider>
        </InfoWrapper>
        {spallePileCollegamentiTableExtraTableWatch?.length === 0 && (
          <GridWrap item xs={12} paddingTop={'0px !important'}>
            <Typography>
              Nessun elemento aggiuntivo presente in questo elemento
            </Typography>
          </GridWrap>
        )}
      </GridWrap>
      {spallePileCollegamentiTableExtraTableWatch?.length > 0 && (
        <>
          {!inspectionDisabled && !isViewingInspection && (
            <ElementiAggiuntiviForm
              elementiExtraFields={
                spallePileCollegamentiTableExtraTableWatch || []
              }
              selected={selectedElementiExtra}
              setSelected={setSelectedElementiExtra}
              elementiExtraTable={`spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable`}
              selectedIdx={selectedIdx}
            />
          )}
          <DrawerMedia
            open={open}
            setOpen={setOpen}
            title={'Elementi Aggiuntivi'}
            infoPanel="Per un'ottimizzazione nel report, si consiglia di eseguire foto in orizzontale in rapporto 4:3."
            dataType="video/*,image/*"
            uploadType={UploadMedia.media}
            type={FieldType.images}
            formName={`spallePileCollegamentiTable[${selectedIdx}].elementiAggiuntiviTable[${drawerMediaIndex}].media`}
            mediaGroup={[MediaGroup.Struttura]}
          />
          <GridWrap container spacing={2} mt={2}>
            <GridWrap item xs={12}>
              <Table
                data={spallePileCollegamentiTableExtraTableWatch || []}
                config={dataConfigElementiExtra}
                hasCheckbox={!inspectionDisabled && !isViewingInspection}
                rowActions={
                  !inspectionDisabled && !isViewingInspection
                    ? [
                        {
                          onClick: item => {
                            editRowsElementiExtra(item);
                            setSelectedElementiExtra([item]);
                          },
                          icon: <EditIcon />,
                        },
                      ]
                    : []
                }
                mediaActions={[
                  {
                    onClick: item => {
                      setDrawerMediaIndex(
                        spallePileCollegamentiTableExtraTableWatch.findIndex(
                          el => el.id === item.id
                        )
                      );
                      setOpen(true);
                    },
                    icon: <MediaIcon />,
                  },
                ]}
                selected={selectedElementiExtra}
                onSelectAllClick={handleSelectAllClickElementiExtra}
                setSelected={setSelectedElementiExtra}
              />
            </GridWrap>
          </GridWrap>
        </>
      )}
    </>
  );
};
ElementiAggiuntiviSection.propTypes = {
  selectedIdx: PropTypes.number,
};
export default ElementiAggiuntiviSection;
